import { useState } from "react";

import SearchIcon from "@mui/icons-material/SearchRounded";
import { IconButton, InputAdornment, TextField } from "@mui/material";

interface Props {
  placeholder: string;
  onChange: (value: string | null) => void;
  initialValue?: string;
  width?: number | string;
}

/** Shared search box: a text field with a trailing search icon that commits on Enter or icon click. */
export function SearchField({ placeholder, onChange, initialValue = "", width }: Props) {
  const [inputValue, setInputValue] = useState(initialValue);

  function triggerSearch() {
    onChange(inputValue.trim() || null);
  }

  return (
    <TextField
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          triggerSearch();
        }
      }}
      placeholder={placeholder}
      size="small"
      slotProps={{
        input: {
          "aria-label": placeholder,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={triggerSearch} edge="end" size="small" aria-label={placeholder}>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
      sx={{
        width,
        "& .MuiIconButton-root": {
          color: "action.active",
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiIconButton-root": {
          color: "primary.main",
        },
      }}
    />
  );
}
